import { STATS_ENDPOINT } from "../constants/settings";
import { myFetch } from "../helpers/myFetch";

export const getStats = () => {
  return myFetch(`${STATS_ENDPOINT}`, "GET");
};
